





































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel } from '@/models/pagedlistmodel';
import {
  RepairOrderResponseViewModel,
  OpenRepairOrderViewModel,
  AttachmentInfoViewModel,
  AddAttachmentModel,
} from '@/models/fixedops/repairorder';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { Utils } from '@/helper/utils';
import { Team } from '@/models/admin/team';
import { Base } from '@/components/common/base';
import {
  attachmentTypeService,
  repairOrderService,
  teamService,
} from '@/shared';
@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    OpenOrderGrid: () => import('@/components/repairorder/openorder.grid.vue'),
  },
})
export default class OpenRepairOrderPage extends Base {
  public pagedRO: OpenRepairOrderViewModel[] = [];

  public pagination = new PaginationModel('repairOrderNumber');
  public loading: boolean = false;
  public teamLoading: boolean = false;

  public actions: any[] = [];
  public form: any = {};
  public formFields: Array<VFields<any>> = [];

  public openOrder: RepairOrderResponseViewModel = {};
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public addAttachmentTypeModel: AddAttachmentModel = {};
  public storeTeams: any[] = [];
  public attachmentTypes: AttachmentType[] = [];

  public roNumber = '';
  public preventPaginationCall: boolean = false;
  public fileRef: any;
  public filters: string = '';
  public fromLocal: boolean = true;
  public selectedFilter = [];
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
  };
  public isbuttonLoading: boolean = false;
  public childMethodName: string = '';
  public childProgress: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'search') {
      this.search();
    }
    if (methodName === 'fetchFromServer') {
      this.fetchFromServer();
    }
    if (
      methodName !== '' &&
      (methodName === 'search' || methodName === 'fetchFromServer')
    ) {
      this.$emit('resetMethodName', methodName);
    }
  }

  public resetMethodName(methodName): void {
    this.$emit('resetMethodName', methodName);
  }

  public updateChildToolBar(buttons): void {
    if (this.flags.showForm) {
      this.updateToolBar(buttons);
    } else {
      this.updateToolBar(null);
    }
  }

  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (!additionalButtons) {
      // !additionalButtons
    }

    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      this.childMethodName = newVal;
      this.callMethod(newVal);
    });
    this.$watch('childProgress', (newVal, oldVal) => {
      this.$emit('update:progress', newVal);
    });

    if (this.$route.query.filter) {
      this.filters = this.$route.query.filter as string;
    }
    if (this.$route.query.fromlocal) {
      this.fromLocal = Boolean(this.$route.query.fromlocal);
    }
    this.getStoreTeams();
  }

  public search(): void {
    this.isbuttonLoading = true;
    this.filters = this.selectedFilter.join(',');
    this.fromLocal = true;
    this.$router
      .push({
        name: 'app.repairorders.open',
        query: { filter: this.filters, fromlocal: this.fromLocal.toString() },
      })
      .catch((ex) => {
        console.log(ex);
      });
    this.getopenOrders();
  }
  public fetchFromServer(): void {
    this.isbuttonLoading = true;
    this.filters = this.selectedFilter.join(',');
    this.fromLocal = false;
    this.$router
      .push({
        name: 'app.repairorders.open',
        query: { filter: this.filters, fromlocal: this.fromLocal.toString() },
      })
      .catch((ex) => {
        console.log(ex);
      });
    this.getopenOrders();
  }

  public async getStoreTeams(): Promise<void> {
    try {
      this.teamLoading = true;
      const response = await teamService.getTeamsSelect(this.filters);
      this.storeTeams = response.results;
      if (!this.filters) {
        this.selectedFilter = this.storeTeams
          .filter((f) => {
            return f.selected;
          })
          .map((m) => m.id);
      } else {
        this.selectedFilter = this.filters.split(',');
      }
    } finally {
      this.teamLoading = false;
    }
    this.getopenOrders();
  }

  public async getopenOrders(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await repairOrderService.getOpenOrders(
        this.filters,
        this.fromLocal
      );
      this.openOrder = response;
      this.updateOrderItems(this.openOrder);

      this.pagedRO = this.openOrder.openRepairOrders;
      this.pagination.totalItems = this.openOrder.openRepairOrders.length;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
      this.isbuttonLoading = false;
    }
  }

  public updateOrderItems(order: RepairOrderResponseViewModel): void {
    if (order.openRepairOrders && order.openRepairOrders.length > 0) {
      order.openRepairOrders.forEach((or) => {
        if (order.userList) {
          const serviceWriter = order.userList.find((user) => {
            return user.dmsServiceWriterID === or.serviceWriterID;
          });
          if (serviceWriter) {
            or.serviceWriterName =
              serviceWriter.firstName + ' ' + serviceWriter.lastName;
          } else {
            or.serviceWriterName = or.serviceWriterID;
          }
        }
        if (or.paymentDetail && or.paymentDetail.paymentResponses.length > 0) {
          const approvedPayments = or.paymentDetail.paymentResponses.filter(
            (x) => {
              return x.status === 'Approved';
            }
          );
          if (approvedPayments && approvedPayments.length > 0) {
            const totalPaid = approvedPayments
              .map((m) => {
                return Number(m.approvedAmount);
              })
              .reduce((total, sum) => {
                return Number(total) + Number(sum);
              });
            if (totalPaid === or.paymentDetail.amount) {
              or.completePayment = true;
            } else {
              or.completePayment = false;
            }
          } else {
            or.completePayment = false;
          }
        }
      });
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public async getAttachmentTypes(): Promise<void> {
    try {
      const response = await attachmentTypeService.getAttachmentTypesAsync(
        this.pagination
      );
      this.attachmentTypes = response.results;
      this.setAttachmentTypeItems('attachmentTypeId', this.attachmentTypes);
    } finally {
      // this.hideLoader();
    }
  }
  public setAttachmentTypeItems(fieldname: string, value: any[]) {
    const field = this.formFields.find((m) => {
      return m.key === fieldname;
    });
    if (field) {
      field.templateOptions.items = value;
    }
  }

  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }
}
